import { Typography } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { ERROR_COLORS, GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { AsterChip } from 'asterX-UI/Chip'
import { getStatusColor } from 'lib/constants/deals'
import { getFomattedDate, getFormattedFiltersDate } from 'lib/utils'

export const eventHistoryColumns = [
  'Статус ',
  'Тип действия',
  'Результат',
  'Менеджер',
  'Номер телефона',
  'Дата создания',
  'Срок действия',
  'Комментарий',
  ''
]

export const eventHistoryRows = list => {
  if (!list) {
    return []
  }

  const sortedEvents = list.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))

  return sortedEvents?.map(item => {
    return [
      <Typography
        style={{
          color:
            item?.established === null ? GRAY_COLORS[500] : item?.established ? SUCCESS_COLORS[500] : ERROR_COLORS[500],
          fontSize: 14
        }}
      >
        {item?.established === null
          ? 'Администратор'
          : item?.established
          ? 'Контакт установлен'
          : 'Контакт не установлен'}
      </Typography>,
      item?.type ? <AsterChip label={item?.type?.name} style={getStatusColor(item?.type?.code)} /> : '-',
      item?.result ? <AsterChip label={item?.result?.name} style={getStatusColor(item?.result?.code)} /> : '-',
      item?.createdByFullName || '-',
      item?.phoneNumber?.toString()?.toPhone() || '-',
      getFormattedFiltersDate(item?.createdDate),
      getFomattedDate(item?.dueDate),
      <Typography style={{ wordBreak: 'break-word', fontSize: 14 }}>{item?.description}</Typography>,
      !item?.result && {
        isButton: true,
        label: (
          <>
            <Add />
            <span>результат</span>
          </>
        ),
        data: { id: item?.id }
      }
    ]
  })
}
